import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { ToggleSwitch } from '../../ToggleSwitch';
import countriesJSON from '../../../utils/countries.json';
import { ModalFormBusiness } from '../../Modal/ModalFormBusiness';
import { strNoAccentNoSpecialChar } from '../../../utils/format';
import { UploadFile } from '../../UploadFile';
import { uploadFileOnboardingLaunched } from '../../../store/reducer';

const ShareHolderForm2 = ({ formValue, setFormValue, validate }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // toggles states
  const [enabledShareholder2, setEnabledShareholder2] = useState(false);
  const [enabledAdministrator2, setEnabledAdministrator2] = useState(false);

  // input value state to Reset
  const [eventToReset, setEventToReset] = useState(null);

  // informations modale :
  const [openModal, setOpenModal] = useState(false);

  const hideModal = () => {
    setOpenModal(false);
  };

  // Form data
  const initialValues = {
    shareholder2lastName: formValue.shareholder2lastName,
    shareholder2firstName: formValue.shareholder2firstName,
    shareholder2birthday: formValue.shareholder2birthday,
    shareholder2nationality: formValue.shareholder2nationality,
    shareholder2birthCountry: formValue.shareholder2birthCountry,
    shareholder2birthCity: formValue.shareholder2birthCity,
    shareholder2email: formValue.shareholder2email,
    shareholder2adress: formValue.shareholder2adress,
    shareholder2zipCode: formValue.shareholder2zipCode,
    shareholder2city: formValue.shareholder2city,
    shareholder2country: formValue.shareholder2country,
    // shareholder2identityFiles: formValue.shareholder2identityFiles,
    shareholder2adressFiles: formValue.shareholder2adressFiles,
    shareholder2declaration: formValue.shareholder2declaration,
    enabledShareholder2: formValue.enabledShareholder2,
    enabledAdministrator2: formValue.enabledAdministrator2
  };

  // Form Submitting Function
  const signup = () => {
    window.scrollTo(0, 0);
  };

  // Form Validation Schema
  const validationSchema = Yup.object().shape({
    shareholder2lastName: Yup.string()
      .required(t("firstNameRequired"))
      .nullable(),
    shareholder2firstName: Yup.string()
      .required(t("lastNameRequired"))
      .nullable(),
    shareholder2birthday: Yup.date()
      .required(t("signUpInfos.dateOfBirthRequired"))
      .nullable(),
    shareholder2nationality: Yup.string()
      .required(t("signUpInfos.nationalityRequired"))
      .nullable(),
    shareholder2birthCountry: Yup.string()
      .required(t("signUpInfos.birthCountryRequired"))
      .nullable(),
    shareholder2birthCity: Yup.string()
      .required(t("signUpInfos.birthCityRequired"))
      .nullable(),
    shareholder2email: Yup.string()
      .required(t("signUpForm.emailRequired"))
      .email(t("signUpForm.emailType"))
      .nullable(),
    shareholder2adress: Yup.string()
      .required(t("signUpInfos.adressRequired"))
      .nullable(),
    shareholder2zipCode: Yup.number()
      .required(t("signUpInfos.cpRequired"))
      .positive()
      .integer()
      .nullable(),
    shareholder2city: Yup.string()
      .required(t("signUpInfos.cityRequired"))
      .nullable(),
    shareholder2country: Yup.string()
      .required(t("signUpInfos.countryRequired"))
      .nullable(),
    // shareholder2identityFiles: Yup.array()
    //   .nullable(),
    shareholder2adressFiles: Yup.array()
      .nullable(),
    shareholder2declaration: Yup.array()
      .nullable(),
    enabledShareholder2: Yup.bool()
      .nullable(),
    enabledAdministrator2: Yup.bool()
      .nullable()
  });
  const countriesMapped = countriesJSON;

  // tailwind reusable css
  const sectionContainer = "w-full flex flex-col md:flex-row justify-between items-start md:items-center mb-4 md:mb-6";
  const sectionContainerSpaced = "w-full flex flex-col md:flex-row justify-between items-start md:items-center mb-6";

  // Upload file on S3 function
  const uploadFile = (file, identificator) => {
    dispatch(uploadFileOnboardingLaunched({ file, identificator }));
  };
  return (
    <>
      <h2 className="text-sm md:text-s font-bold w-full mx-auto lg:w-5/6 pb-2">{t("shareholderForm.addShareholderForm")}</h2>
      <div className="w-full mx-auto">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validate={(values) => {
            const errors = {};
            // For validate file's input
            if (values.shareholder2adressFiles === null || values.shareholder2adressFiles.length === 0) {
              errors.shareholder2adressFiles = t("signUpBusiness.fileRequired");
            } else if (values.shareholder2declaration === null || values.shareholder2declaration.length === 0) {
              errors.shareholder2declaration = t("signUpBusiness.fileRequired");
            } else if (values.shareholder2adressFiles.length > 1) {
              errors.shareholder2adressFiles = t("signUpBusiness.numberOfFile");
            } else if (values.shareholder2declaration.length > 1) {
              errors.shareholder2declaration = t("signUpBusiness.numberOfFile");
            } else {
              values.shareholder2adressFiles.forEach((value) => {
                if (value.size > 3000000) {
                  errors.shareholder2adressFiles = (t("signUpBusiness.fileSize"));
                } else if (value.size < 32000) {
                  errors.shareholder2adressFiles = (t("signUpBusiness.fileToSmall"));
                }
              });
              values.shareholder2declaration.forEach((value) => {
                if (value.size > 3000000) {
                  errors.shareholder2declaration = (t("signUpBusiness.fileSize"));
                } else if (value.size < 32000) {
                  errors.shareholder2declaration = (t("signUpBusiness.fileToSmall"));
                }
              });
            }
            return errors;
          }}
          onSubmit={signup}
        >
          {({ errors, touched, values, setFieldValue, handleChange }) => (
            <Form className="mx-auto w-5/6 flex flex-col justify-center items-center">
              <div className={sectionContainerSpaced}>
                <div className="w-full">
                  <label className="block text-xxms font-medium">{`${t('lastName')}  *`}</label>
                  <Field
                    id="shareholder2lastName"
                    name="shareholder2lastName"
                    type="text"
                    onChange={(e) => {
                      handleChange(e);
                      setFormValue((prevState) => ({
                        ...prevState,
                        [e.target.name]: e.target.value
                      }));
                    }}
                    placeholder={t('lastName')}
                    className="w-full border-grey-light rounded text-xxms text-gray-500"
                  />
                  {errors.shareholder2lastName && touched.shareholder2lastName ? (
                    <p className="text-red-600 text-center md:text-left">{errors.shareholder2lastName}</p>
                  ) : null}
                </div>
              </div>

              <div className={sectionContainerSpaced}>
                <div className="w-full">
                  <label className="block text-xxms font-medium">{`${t('firstName')}  *`}</label>
                  <Field
                    id="shareholder2firstName"
                    name="shareholder2firstName"
                    type="text"
                    onChange={(e) => {
                      handleChange(e);
                      setFormValue((prevState) => ({
                        ...prevState,
                        [e.target.name]: e.target.value
                      }));
                    }}
                    placeholder={t('firstName')}
                    className="w-full border-grey-light rounded text-xxms text-gray-500"
                  />
                  {errors.shareholder2firstName && touched.shareholder2firstName ? (
                    <p className="text-red-600 text-center md:text-left">{errors.shareholder2firstName}</p>
                  ) : null}
                </div>
              </div>

              <div className={sectionContainerSpaced}>
                <div className="w-full">
                  <label className="block text-xxms font-medium">{`${t('signInForm.email')}  *`}</label>
                  <Field
                    id="shareholder2email"
                    name="shareholder2email"
                    type="email"
                    onChange={(e) => {
                      handleChange(e);
                      setFormValue((prevState) => ({
                        ...prevState,
                        [e.target.name]: e.target.value
                      }));
                    }}
                    placeholder="ex : antoine.dupont@company.com"
                    className="w-full border-grey-light rounded text-xxms text-gray-500"
                  />
                  {errors.shareholder2email && touched.shareholder2email ? (
                    <p className="text-red-600 text-center md:text-left">{errors.shareholder2email}</p>
                  ) : null}
                </div>
              </div>

              <div className={sectionContainer}>
                <div className="w-full md:flex">
                  {/* Birthdate field */}
                  <div className="w-full md:1/5 md:pr-4">
                    <label className="block text-xxms font-medium">{`${t('signUpInfos.dateOfBirth')}  *`}</label>
                    <Field
                      id="shareholder2birthday"
                      name="shareholder2birthday"
                      type="date"
                      onChange={(e) => {
                        handleChange(e);
                        setFormValue((prevState) => ({
                          ...prevState,
                          [e.target.name]: e.target.value
                        }));
                      }}
                      className="w-full border-grey-light rounded text-xxms text-gray-500"
                    />
                    {errors.shareholder2birthday && touched.shareholder2birthday ? (
                      <p className="text-red-600 text-center md:text-left">{errors.shareholder2birthday}</p>
                    ) : null}
                  </div>
                  {/* Nationality field */}
                  <div className="w-full md:w-4/5 mb-4 md:mb-0 mt-4 md:mt-0">
                    <label className="block text-xxms font-medium">{`${t('signUpInfos.nationality')}  *`}</label>
                    <select
                      id="shareholder2nationality"
                      name="shareholder2nationality"
                      defaultValue=""
                      type={values.shareholder2nationality}
                      onChange={(e) => {
                        handleChange(e);
                        setFormValue((prevState) => ({
                          ...prevState,
                          [e.target.name]: e.target.value
                        }));
                      }}
                      className="w-full border-grey-light rounded text-xxms text-gray-500"
                    >
                      <option value="" disabled label={t("selectNationality")} />
                      {
                        countriesMapped.map((country) => (
                          <option key={country.num_code} value={country.alpha_2_code}>
                            {country.nationality}
                          </option>
                        ))
                      }
                    </select>
                    {errors.shareholder2nationality && touched.shareholder2nationality ? (
                      <p className="text-red-600 text-center md:text-left">{errors.shareholder2nationality}</p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className={sectionContainer}>
                <div className="w-full md:flex">
                  {/* BirthCountry field */}
                  <div className="w-full md:1/5 md:pr-4">
                    <label className="block text-xxms font-medium">{`${t('signUpInfos.birthCountry')}  *`}</label>
                    <select
                      id="shareholder2birthCountry"
                      name="shareholder2birthCountry"
                      defaultValue=""
                      type={values.shareholder2birthCountry}
                      onChange={(e) => {
                        handleChange(e);
                        setFormValue((prevState) => ({
                          ...prevState,
                          [e.target.name]: e.target.value
                        }));
                      }}
                      className="w-full border-grey-light rounded text-xxms text-gray-500"
                    >
                      <option value="" disabled label={t("selectCountry")} />
                      {
                        countriesMapped.map((country) => (
                          <option key={country.alpha_2_code} value={country.alpha_2_code}>
                            {country.en_short_name}
                          </option>
                        ))
                      }
                    </select>
                    {errors.shareholder2birthCountry && touched.shareholder2birthCountry ? (
                      <p className="text-red-600 text-center md:text-left">{errors.shareholder2birthCountry}</p>
                    ) : null}
                  </div>
                  {/* birthCity  field */}
                  <div className="w-full md:w-4/5 mb-4 md:mb-0 mt-4 md:mt-0">
                    <label className="block text-xxms font-medium">{`${t('signUpInfos.birthCity')}  *`}</label>
                    <Field
                      id="shareholder2birthCity"
                      name="shareholder2birthCity"
                      type="text"
                      onChange={(e) => {
                        handleChange(e);
                        setFormValue((prevState) => ({
                          ...prevState,
                          [e.target.name]: e.target.value
                        }));
                      }}
                      className="w-full border-grey-light rounded text-xxms text-gray-500"
                    />
                    {errors.shareholder2birthCity && touched.shareholder2birthCity ? (
                      <p className="text-red-600 text-center md:text-left">{errors.shareholder2birthCity}</p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className={sectionContainerSpaced}>
                <div className="w-full">
                  <label className="block text-xxms font-medium">{`${t('signUpInfos.adress')}  *`}</label>
                  <Field
                    id="shareholder2adress"
                    name="shareholder2adress"
                    type="text"
                    onChange={(e) => {
                      handleChange(e);
                      setFormValue((prevState) => ({
                        ...prevState,
                        [e.target.name]: e.target.value
                      }));
                    }}
                    placeholder={`ex : ${t("signUpInfos.adressPlaceholder")}`}
                    className="w-full border-grey-light rounded text-xxms text-gray-500"
                  />
                  {errors.shareholder2adress && touched.shareholder2adress ? (
                    <p className="text-red-600 text-center md:text-left">{errors.shareholder2adress}</p>
                  ) : null}
                </div>
              </div>

              <div className={sectionContainer}>
                <div className="w-full">
                  <select
                    id="shareholder2country"
                    name="shareholder2country"
                    defaultValue=""
                    type={values.shareholder2country}
                    onChange={(e) => {
                      handleChange(e);
                      setFormValue((prevState) => ({
                        ...prevState,
                        [e.target.name]: e.target.value
                      }));
                    }}
                    className="w-full border-grey-light rounded text-xxs text-gray-500"
                  >
                    <option value="" disabled label={t("selectCountry")} />
                    {
                      countriesMapped.map((country) => (
                        <option key={country.alpha_3_code} value={country.alpha_2_code}>
                          {country.en_short_name}
                        </option>
                      ))
                    }
                  </select>
                  {errors.shareholder2country && touched.shareholder2country ? (
                    <p className="text-red-600 text-center md:text-left">{errors.shareholder2country}</p>
                  ) : null}
                </div>
              </div>

              <div className={sectionContainer}>
                <div className="w-full md:flex">
                  {/* ZipCode field */}
                  <div className="w-full md:1/5 md:pr-4">
                    <Field
                      id="shareholder2zipCode"
                      name="shareholder2zipCode"
                      type="text"
                      onChange={(e) => {
                        handleChange(e);
                        setFormValue((prevState) => ({
                          ...prevState,
                          [e.target.name]: parseInt(e.target.value, 10)
                        }));
                      }}
                      placeholder="ex : 75000"
                      className="w-full border-grey-light rounded text-xxms text-gray-500"
                    />
                    {errors.shareholder2zipCode && touched.shareholder2zipCode ? (
                      <p className="text-red-600 text-center md:text-left">{errors.shareholder2zipCode}</p>
                    ) : null}
                  </div>
                  {/* City field */}
                  <div className="w-full md:w-4/5 mb-4 md:mb-0 mt-4 md:mt-0">
                    <Field
                      id="shareholder2city"
                      name="shareholder2city"
                      type="text"
                      onChange={(e) => {
                        handleChange(e);
                        setFormValue((prevState) => ({
                          ...prevState,
                          [e.target.name]: e.target.value
                        }));
                      }}
                      placeholder="ex : Paris"
                      className="w-full border-grey-light rounded text-xxms text-gray-500"
                    />
                    {errors.shareholder2city && touched.shareholder2city ? (
                      <p className="text-red-600 text-center md:text-left">{errors.shareholder2city}</p>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Required documents section */}
              <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-center">
                <div className="w-full md:w-4/6 lg:w-3/4">
                  <div>
                    <span className="text-xxms font-medium">
                      {t("signUpInfos.obligatory")}
                    </span>
                    <button
                      type="button"
                      className="pt-2"
                      onClick={() => {
                        setOpenModal(!openModal);
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full mb-2 text-xxs italic flex flex-col space-y-1">
                <span>{t("signUpInfos.infoFile")}</span>
                <span>{t("signUpInfos.tipFile")}</span>
              </div>
              {/* Upload ID */}
              {/* <UploadFile
                identificator="shareholder2identityFiles"
                label={t('uploadFileID')}
                onChange={(event) => {
                  if (!values.shareholder2identityFiles) {
                    values.shareholder2identityFiles = [];
                  }
                  const shareholder2identityFilesArray = values.shareholder2identityFiles;
                  if (event.target?.files[0]) {
                    const fileName = event.target?.files[0].name;
                    const fileType = event.target?.files[0].type;
                    const fileSize = event.target?.files[0].size;
                    const file = event.target?.files[0];
                    const reader = new FileReader();
                    reader.onload = () => {
                      setFieldValue("shareholder2identityFiles", shareholder2identityFilesArray.concat({ name: fileName, type: fileType, fileData: reader.result, size: fileSize }));
                      setFormValue((prevState) => ({
                        ...prevState,
                        [event.target.name]: values.shareholder2identityFiles.concat({ docType: 'cni', name: fileName, type: fileType, fileData: reader.result, size: fileSize })
                      }));
                    };
                    reader.readAsDataURL(file);
                  }
                }}
                arrayValues={values.shareholder2identityFiles}
                errors={errors.shareholder2identityFiles}
                touched={touched.shareholder2identityFiles}
                setFormValue={setFormValue}
                formValue={formValue}
                setFieldValue={setFieldValue}
              /> */}
              {/* Upload adress proof */}
              <UploadFile
                identificator="shareholder2adressFiles"
                label={t('adressFiles')}
                onInput={(event) => {
                  setEventToReset(event.target);
                  if (!values.shareholder2adressFiles) {
                    values.shareholder2adressFiles = [];
                  }
                  if (values.shareholder2adressFiles.length >= 1) {
                    values.shareholder2adressFiles = [];
                  } // reset array after wrong upload
                  if (formValue.shareholder2adressFiles.length >= 1) {
                    formValue.shareholder2adressFiles.length = [];
                  } // reset array after wrong upload
                  const shareholder2adressFilesArray = values.shareholder2adressFiles;
                  if (event.target?.files[0]) {
                    const fileName = strNoAccentNoSpecialChar(event.target?.files[0].name);
                    const fileType = event.target?.files[0].type.slice(event.target?.files[0].type.indexOf("/") + 1, event.target?.files[0].type.length); // if file.type = img/png -> fileType = png
                    const fileSize = event.target?.files[0].size;
                    const file = event.target?.files[0];
                    const reader = new FileReader();
                    reader.onload = () => {
                      setFieldValue("shareholder2adressFiles", shareholder2adressFilesArray.concat({ name: fileName, type: fileType, fileData: `${fileName}_${fileSize}_shareholder2adressFiles.${fileType}`, size: fileSize }));
                      setFormValue((prevState) => ({
                        ...prevState,
                        [event.target.name]: values.shareholder2adressFiles.concat({ docType: 'addressProof', name: fileName, type: fileType, fileData: `${fileName}_${fileSize}_shareholder2adressFiles.${fileType}`, size: fileSize })
                      }));
                    };
                    reader.readAsDataURL(file);
                    uploadFile(file, "shareholder2adressFiles");
                  }
                }}
                arrayValues={values.shareholder2adressFiles}
                errors={errors.shareholder2adressFiles}
                touched={touched.shareholder2adressFiles}
                setFormValue={setFormValue}
                formValue={formValue}
                setFieldValue={setFieldValue}
                eventToReset={eventToReset}
              />

              {/* Upload shareholder declaration */}
              <UploadFile
                identificator="shareholder2declaration"
                label={t('shareholderForm.shareholderDeclaration')}
                onInput={(event) => {
                  setEventToReset(event.target);
                  if (!values.shareholder2declaration) {
                    values.shareholder2declaration = [];
                  }
                  if (values.shareholder2declaration.length >= 1) {
                    values.shareholder2declaration = [];
                  } // reset array after wrong upload
                  if (formValue.shareholder2declaration.length >= 1) {
                    formValue.shareholder2declaration.length = [];
                  } // reset array after wrong upload
                  const shareholder2declarationArray = values.shareholder2declaration;
                  if (event.target?.files[0]) {
                    const fileName = strNoAccentNoSpecialChar(event.target?.files[0].name);
                    const fileType = event.target?.files[0].type.slice(event.target?.files[0].type.indexOf("/") + 1, event.target?.files[0].type.length); // if file.type = img/png -> fileType = png
                    const fileSize = event.target?.files[0].size;
                    const file = event.target?.files[0];
                    const reader = new FileReader();
                    reader.onload = () => {
                      setFieldValue("shareholder2declaration", shareholder2declarationArray.concat({ name: fileName, type: fileType, fileData: `${fileName}_${fileSize}_shareholder2declaration.${fileType}`, size: fileSize }));
                      setFormValue((prevState) => ({
                        ...prevState,
                        [event.target.name]: values.shareholder2declaration.concat({ docType: 'shareholder', name: fileName, type: fileType, fileData: `${fileName}_${fileSize}_shareholder2declaration.${fileType}`, size: fileSize })
                      }));
                    };
                    reader.readAsDataURL(file);
                    uploadFile(file, "shareholder2declaration");
                  }
                }}
                arrayValues={values.shareholder2declaration}
                errors={errors.shareholder2declaration}
                touched={touched.shareholder2declaration}
                setFormValue={setFormValue}
                formValue={formValue}
                setFieldValue={setFieldValue}
                eventToReset={eventToReset}
              />

              {/* Toggle buttons group */}
              <ToggleSwitch
                id="enabledShareholder2"
                nameSwitch="enabledShareholder2"
                checked={enabledShareholder2}
                label={t("signUpInfos.shareholder")}
                onChange={(e) => {
                  handleChange(e);
                  setFormValue((prevState) => ({
                    ...prevState,
                    [e.target.name]: e.target.checked
                  }));
                  setEnabledShareholder2(e.target.checked);
                }}
              />

              <ToggleSwitch
                id="enabledAdministrator2"
                nameSwitch="enabledAdministrator2"
                checked={enabledAdministrator2}
                label={t("signUpInfos.administrator")}
                onChange={(e) => {
                  handleChange(e);
                  setFormValue((prevState) => ({
                    ...prevState,
                    [e.target.name]: e.target.checked
                  }));
                  setEnabledAdministrator2(e.target.checked);
                }}
              />

              <div className="w-full flex flex-col-reverse md:flex-row justify-center items-center my-6">
                <button
                  type="button"
                  className="border border-grey-light mt-4 md:mt-0 bg-white py-2 px-4 rounded-md shadow-sm text-xxms font-medium text-black hover:bg-orange-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange"
                  onClick={() => validate(false)}
                >
                  {t("shareholderForm.goBack")}
                </button>
                <button
                  type="submit"
                  disabled={(Object.keys(errors).length !== 0) ? "disabled" : ""}
                  onClick={() => validate(false)}
                  className="border border-grey-light md:ml-3 inline-flex justify-center py-2 px-4 shadow-sm text-xxms font-medium rounded-md text-black bg-white hover:bg-orange-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange"
                >
                  {t("shareholderForm.add")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <ModalFormBusiness showModal={openModal} hideModal={hideModal} simple shareholder />
    </>
  );
};

export default ShareHolderForm2;
